import { push } from 'connected-react-router'
import { connect } from 'react-redux'

import ErrorPage from './ErrorPage'

const mapStateToProps = ({ system }) => ({
  errorMessage: system.errorMessage,
  errorTill: system.errorTill,
  errorType: system.errorType,
})

const mapDispatchToProps = {
  goToMainPage: () => push('/'),
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage)
